import React from 'react';
// Import React Table.
import ReactTable from "react-table";
import "react-table/react-table.css";

// Import React Table HOC Fixed columns.
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class StickyTable extends React.Component {
  state = {
    stuckTop: false,
    helperHeight: 0,
  };

  contentHeight = 0;
  frameId = 0;
  stickyDiv = React.createRef();
  stickyDivInner = React.createRef();

  measureElm() {
    if (this.stickyDivInner.current) {
      return this.stickyDivInner.current.clientHeight;
    }
    return 0;
  }

  handleScroll = () => {
    const stickyDiv = this.stickyDiv.current || null;
    const scrollTarget = window;
    const {stuckTop} = this.state;

    this.frameId = 0;

    if (!stickyDiv) {
      return;
    }

    let scrollRect = { // scrollTarget is the window
      height: scrollTarget.innerHeight,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      x: scrollTarget.scrollX,
      y: scrollTarget.scrollY,
    };

    let stickyRect = stickyDiv.getBoundingClientRect();

    if (stickyRect.top < scrollRect.top) {
      if (stuckTop) {
        if (stickyRect.bottom >= 80) {
          this.setState({helperHeight: stickyRect.bottom});
        }
        else {
          this.setState({stuckTop: false, helperHeight: 0});
        }
      }
      else {
        if (stickyRect.bottom >= 80) {
          this.contentHeight = stickyRect.height;
          this.setState({stuckTop: true, helperHeight: stickyRect.bottom});
        }
      }
    }
    else if (stuckTop) {
      this.setState({stuckTop: false, helperHeight: 0});
    }
  }

  debouncedScroll = () => {
    if (!this.frameId) {
      const frameId = requestAnimationFrame(this.handleScroll);
      this.frameId = frameId;
    }
  }

  addEvents() {
    if (window && this.stickyDiv.current) {
      window.addEventListener('scroll', this.debouncedScroll);
    }
  }

  removeEvents() {
    if (window) {
      window.removeEventListener('scroll', this.debouncedScroll);
    }

    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
    }
  }

  componentDidMount() {
    // Don't mointor the scroll - no sticky needed.
    // this.addEvents();
    // this.handleScroll();
  }

  componentWillUnmount() {
    this.removeEvents();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.loading && !this.props.loading && prevState.stuckTop) {
      this.stickyDiv.current.scrollIntoView();
    }
  }

  render() {
    const {helperHeight, stuckTop} = this.state;
    const contentHeight = this.contentHeight;

    return (
      <div
        className={"sticky-table" + (stuckTop ? " sticky-active" : "")}
        style={(stuckTop && contentHeight) ? {minHeight: contentHeight} : {}}
        ref={this.stickyDiv}>
        <div
          className="sticky-table-inner"
          style={(stuckTop && helperHeight) ? {height: helperHeight} : {}}
          ref={this.stickyDivInner}>
          <ReactTableFixedColumns
            style={{height: 'calc(100vh - 5rem)'}}
            {...this.props}
            getTbodyProps={() => {
              return {
                style: (stuckTop && helperHeight) ? {marginTop: (helperHeight - contentHeight)} : {}
              }
            }} />
        </div>
      </div>
    )
  }
}

export default StickyTable;
